
import { defineComponent } from "vue";
import * as apiClient from "@/apiclient";
import common from "@/config/common";
import helper from "@/utils/helper";
import iCOBRABenefit from "@/types/iCOBRABenefit";

export default defineComponent({
  props: {
    benefit: {
      type: Object as () => iCOBRABenefit,
      required: true,
    },
    dependentData: {
      type: Array as () => apiClient.GetAllDependentDto[],
      required: true,
    },
  },
  data() {
    return {
      common,
      helper,
    };
  },
  mounted() {
    this;
  },
  methods: {
    coverageDependentName(dependentId: number): string {
      const dependent = this.dependentData.find(
        (person) => person.electionDependentId === dependentId
      );

      return dependent ? dependent.firstName + " " + dependent.lastName : "";
    },
    tierName(benefit: iCOBRABenefit) {
      if (benefit.benefitRateTypeId! === common.benefit.tier) {
        const selectedCoverage = benefit.coverageOptions!.find(
          (option) => option.isSelected
        );
        if (selectedCoverage) {
          return selectedCoverage.tierLevelName;
        }
      } else if (benefit.benefitRateTypeId === common.benefit.single) {
        return "Single";
      } else if (benefit.benefitRateTypeId === common.benefit.unique) {
        return "Unique";
      }
    },
    doesBenefitHaveSubsidy(): boolean {
      if (this.benefit.coverageOptions!.length > 0) {
        return this.benefit.coverageOptions!.some(
          (option) => option.subsidies!.length > 0
        );
      }

      return this.benefit.subsidies!.length > 0;
    },
    getSubsidyMessage(): string {
      return (
        "* Amount due today and monthly premium include an employer subsidy total of $" +
        this.getSubsidyAmount(this.benefit).toFixed(2) +
        ". " +
        this.benefit.subsidyDetails
      );
    },
    coverageDependentRelation(dependentId: number) {
      const dependent = this.dependentData.find(
        (person) => person.electionDependentId === dependentId
      );

      return dependent ? dependent.relationshipName : "";
    },
    formatEffectiveDate(date: string): string {
      if (!date) {
        return "";
      }
      const effectiveDate = new Date(date);
      effectiveDate.setDate(effectiveDate.getDate() + 1);
      return helper.formatDate(effectiveDate.toString());
    },
    monthlyPrice(benefit: iCOBRABenefit) {
      if (benefit.benefitRateTypeId === common.benefit.tier) {
        const selectedCoverage = benefit.coverageOptions!.find(
          (option) => option.isSelected
        );
        if (selectedCoverage) {
          console.log(selectedCoverage);

          return helper.formatNumber(selectedCoverage.monthlyPremiumRate!);
        }
      } else if (benefit.benefitRateTypeId === common.benefit.single) {
        return helper.formatNumber(benefit.singleMonthlyPremiumRate!);
      } else if (benefit.benefitRateTypeId === common.benefit.unique) {
        return helper.formatNumber(benefit.uniqueMonthlyPremiumRate!);
      }
    },
    formatDate(date: string): string {
      if (!date) {
        return "";
      }
      return helper.formatDate(date);
    },
    getSubsidyAmount(benefit: iCOBRABenefit): number {
      if (benefit.benefitRateTypeId === common.benefit.tier) {
        var foundTiers = benefit.coverageOptions.filter(
          (option) => option.isSelected == true
        );

        if (foundTiers.length > 0) {
          return foundTiers[0].subsidyTotal ?? 0;
        }
      }

      return benefit.subsidyTotal!;
    },
  },
});
